import { useEffect } from "react";

const SITE_URL = "https://studiocomm.art";

interface PageMeta {
  title: string;
  description?: string;
  /** Path starting with "/" — used to build the canonical URL */
  canonicalPath?: string;
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
}

/**
 * Sets document title, meta description, canonical link and the matching
 * Open Graph / Twitter tags for a route. The build-time prerender snapshot
 * (scripts/prerender.mjs) captures these, so crawlers that don't run JS get
 * per-route metadata too.
 */
export function usePageMeta({ title, description, canonicalPath }: PageMeta) {
  useEffect(() => {
    document.title = title;
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }

    if (canonicalPath) {
      const url = `${SITE_URL}${canonicalPath}`;
      let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = url;
      setMeta("property", "og:url", url);
    }
  }, [title, description, canonicalPath]);
}
